import { inserStyle, setTheme, getTheme } from './utils'

inserStyle()
setTheme()
export default getTheme()
